import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { DataContext } from '../../Provider/dataProvider';
import { fetchWithAuth } from '../../utils/authUtils';
import '../../css/legal.css';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

const DeleteAccountPage = () => {
    const { data, clearAccessToken } = useContext(DataContext);
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [confirmText, setConfirmText] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');

    useEffect(() => {
        if (!data?.id) {
            navigate('/login', { replace: true, state: { from: '/account/delete' } });
        }
    }, [data?.id, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        try {
            const res = await fetchWithAuth(`${API_BASE}/api/account`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ password, confirmText }),
            });
            const payload = await res.json().catch(() => ({}));
            if (!res.ok || !payload?.success) {
                throw new Error(payload?.message || 'Không thể xóa tài khoản');
            }
            clearAccessToken?.();
            setMessageType('success');
            setMessage('Tài khoản đã được xóa. Cảm ơn bạn đã sử dụng TamCare.');
            setTimeout(() => navigate('/', { replace: true }), 2000);
        } catch (err) {
            setMessageType('error');
            setMessage(err.message || 'Lỗi khi xóa tài khoản');
        } finally {
            setLoading(false);
        }
    };

    if (!data?.id) return null;

    return (
        <div className="tamcare-legal-page">
            <div className="tamcare-delete-account-box">
                <h1>Xóa tài khoản vĩnh viễn</h1>
                <p>
                    Hành động này <strong>không thể hoàn tác</strong>. Dữ liệu sức khỏe, hồ sơ y tế,
                    liên kết người thân và lịch sử chat AI liên quan sẽ bị xóa.
                </p>
                <p>
                    Xem thêm: <Link to="/privacy">Chính sách bảo mật</Link>
                </p>

                {message && (
                    <div
                        className={`tamcare-alert ${messageType === 'success' ? 'tamcare-alert--success' : 'tamcare-alert--error'}`}
                        style={{ marginBottom: 16 }}
                    >
                        {message}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <label htmlFor="delete-password">Mật khẩu (nếu có)</label>
                    <input
                        id="delete-password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Nhập mật khẩu hiện tại"
                        autoComplete="current-password"
                    />

                    <label htmlFor="delete-confirm">
                        Nhập <strong>XÓA TÀI KHOẢN</strong> để xác nhận
                    </label>
                    <input
                        id="delete-confirm"
                        type="text"
                        value={confirmText}
                        onChange={(e) => setConfirmText(e.target.value)}
                        placeholder="XÓA TÀI KHOẢN"
                        required
                    />

                    <button type="submit" disabled={loading}>
                        {loading ? 'Đang xóa...' : 'Xóa tài khoản vĩnh viễn'}
                    </button>
                </form>

                <p className="tamcare-legal-back" style={{ border: 'none', marginTop: 20 }}>
                    <Link to="/profile">← Quay lại hồ sơ</Link>
                </p>
            </div>
        </div>
    );
};

export default DeleteAccountPage;
